import { Integration, IntegrationType, MobileApp } from 'modules/mobileApps/types';

export enum IntegrationOperationType {
  CREATE = 'createIntegration',
  UPDATE = 'updateIntegration',
}

export type IntegrationMetadataContextState = {
  /** Details about the current app. */
  appDetails: MobileApp | undefined;
  /** List of apps and websites that exist in the project. */
  apps: MobileApp[];
  /** List of integrations by IntegrationPlatform that are assigned to this app. */
  assignedIntegrations: IntegrationType;
  /** List of only mobile (iOS and Android) apps that exist in the project. */
  mobileApps: MobileApp[];
  /** The type of change being made to the integration configuration, whether creating or updating. */
  operationType: IntegrationOperationType;
  /** Details of the actively selected integration. */
  selectedIntegration: Integration | undefined;

  setAppDetails: (value: MobileApp) => void;
  setApps: (value: MobileApp[]) => void;
  setAssignedIntegrations: (value: IntegrationType) => void;
  setOperationType: (value: IntegrationOperationType) => void;
  setSelectedIntegration: (value: Integration | undefined) => void;
};
